import { ReactElement } from 'react';

import { AlertIcon, IconFillColor, IconSize, IconWrapper } from '@dreryk/react-components';

type UrgentCellProps = {
   urgent: boolean;
};

export const UrgentCell = (props: UrgentCellProps): ReactElement | null => {
   if (props.urgent) {
      return (
         <IconWrapper testId={'urgent'} fillColor={IconFillColor.ERROR} size={IconSize.NORMAL}>
            <AlertIcon />
         </IconWrapper>
      );
   }

   return null;
};
